import AssetFour from './AssetFour';

export default AssetFour;
